export default __webpack_public_path__ + "static/media/highcontrast.91ef746b.svg";